import { QueryOptions, MutationOptions } from '@apollo/client';
import { GetServerSidePropsContext } from 'next';
import { authorizedApolloClient } from 'server/authorizedApolloClient';

export async function authorizedQuery<T>(context: GetServerSidePropsContext, options: QueryOptions) {
    const client = await authorizedApolloClient(context);
    const res = await client.query<T>(options);
    if (!res?.data) {
        throw new Error('Backend error');
    }

    return res.data;
}

export async function authorizedMutate<T>(
    context: GetServerSidePropsContext, options: MutationOptions,
): Promise<T> {
    const client = await authorizedApolloClient(context);
    const res = await client.mutate<T>(options);
    if (!res?.data) {
        throw new Error('Backend error');
    }

    return res.data;
}
